<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <!-- <div class="back_left" @click="$router.back()"></div> -->
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
    </div>
    <div class="hellotitle">
      {{ $t('c3.well') }} , {{ userName }}
    </div>
		
    <div class="rp_box">
      <div class="balance ">
        <p v-if="vip">
          <span
            v-if="vip.no==0"
            class="vip0span"
          >{{ vip.name }}</span>
          <span
            v-if="vip.no==1"
            class="vip1span"
          >{{ vip.name }}</span>
          <span
            v-if="vip.no==2"
            class="vip2span"
          >{{ vip.name }}</span>
          <span
            v-if="vip.no==3"
            class="vip3span"
          >{{ vip.name }}</span>
        </p>
        <p>
          {{ $t('sky.jifen') }}
        </p>
        <p>
          {{ parseInt(funds) }} 
        </p>
      </div>
      <!-- <img src="../images/ban1/qian.png" class="topRightIcon"> -->
      <!-- <div  class="rp_title">{{$t('c3.sum')}}</div>
		    <div  class="rp_money">
		            <img src="../images/ban1/qianIcon.png" >
		        {{funds}}
		    </div> -->
      <!-- <div  class="rp_tips" >
			   Setiap 1 Expedia Poin bernilai 1 (satu) IDR saat digunakan untuk bertransaksi
		    </div> -->
    </div>
    <div class="btn_box">
      <div
        class="btn flexCenter"
        @click="$router.push('/cash')"
      >
        {{ $t('moneybag.withdraw') }}
      </div>
      <div
        class="btn btn1 flexCenter"
        @click="$router.push('/invest')"
      >
        {{ $t('moneybag.recharge') }}
      </div>
    </div>
    <div class="manager_box">
      <div
        class="box"
        @click="$router.push('/addcountUsdt')"
      >
        <div class="icon">
          <img src="../images/ban1/link.png">
          <div><span>{{ $t('account.add') }}</span></div>
        </div>
        <div class="right">
          <img src="../images/ban1/right.png">
        </div>
      </div>
      <div
        class="box"
        @click="$router.push('/funds')"
      >
        <div class="icon">
          <img src="../images/ban1/time.png">
          <div><span>{{ $t('moneybag.myWallet') }}</span></div>
        </div>
        <div class="right">
          <img src="../images/ban1/right.png">
        </div>
      </div>
    </div>
    <!-- <div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
			<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
			<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
			<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
		</div>
		<div class="footerdesc">
			<div class="version">
				Expedia 2025.46.1 (252432001)
			</div>
			<div class="copyright">
			 © Hak Cipta 2012-2025 Expedia Group Semua hak cipta dilindungi undang-undang.
			</div>
		</div> -->
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: null,
                vip: null,
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                frozen: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
			this.$parent.footer('moneybag');
        },
        mounted() {
            Fetch('/user/funds').then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                for (var i in r.data.reason) {
					switch (i) {
					    case "1":
							r.data.reason[i] = this.$t('moneybag.recharge');
					    	break;
					    case "2":
							r.data.reason[i] = this.$t('moneybag.withdraw');
					    	break;
						case "3":
							r.data.reason[i] = this.$t('moneybag.give');
					   	 	break;
						case "4":
							r.data.reason[i] = this.$t('moneybag.signIn');
					    	break;
						case "5":
							r.data.reason[i] = this.$t('moneybag.share');
					    	break;
					    case "6":
							r.data.reason[i] = this.$t('moneybag.purchase');
					    	break;
						case "7":
							r.data.reason[i] = this.$t('moneybag.redPacket');
					   	 	break;
						case "8":
							r.data.reason[i] = this.$t('moneybag.reward');
					    	break;
						case "9":
							r.data.reason[i] = this.$t('moneybag.welfare');
					    	break;
					    case "10":
							r.data.reason[i] = this.$t('moneybag.invite');
					    	break;
						case "11":
						case "12":
							r.data.reason[i] = this.$t('moneybag.income');
					   	 	break;
					    default:
					    	break;
					
					}
                    this.option.push({
                        text: r.data.reason[i],
                        value: i
                    })
                }
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = parseInt(1*r.data.money + 1*r.data.wx_bankbz);
                this.mymoney = r.data.mymoney;
                this.frozen = r.data.basemoney;
                this.userName = r.data.username;
				this.listd(1);
				if(r.data && r.data.vip){
					this.vip = r.data.vip;
				}
            })
        },
        methods: {
			listd(type){
				var dataf = this.data;
				this.data = null;
				if(dataf && dataf.length>0){
					if(type==1){
						for(var i=0;i<dataf.length;i++){
							dataf[i].show = 1;
						}
					}else if(type==2){
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type !=3 && dataf[i].reason_type !=4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}else{
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type ==3 || dataf[i].reason_type ==4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}
				}
				this.data = dataf;
			},
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
	.user_yw{
		text-align: center;
		width: 96%;
		margin-top: 20px;
		background: #0063d2;
		margin-left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
        display: flex;
		color: #FFF;
        div{
            width: 100%;
        }
		p:nth-child(1){
			font-size: 14px;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 14px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		background: #0063d2;
		margin-left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
			font-size: 14px;
		}
	}

    .detail_box {
        width: 96%;
		margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 10px;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
	.user_money{
		display: block;
		width: 96%;
		margin-left: 2%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			    justify-content: center;
			}
		}
	}
	.but1 {
    background-color: #ffcd00;
    color: #232f3e;
}
.but2 {
    background-color: #232f3e;
    color: #ffcd00;
}

.rp_box {
    display: flex;
    padding-left: 28px;
    padding-right: 28px;
    margin: 11px;
    // background-color: #0064d3;
    border-radius: 15px;
    flex-direction: column;
    // justify-content: flex-end;
    position: relative;
    padding-bottom: 3px;
	border: 1px solid #999;
	color: #000;
	.topRightIcon{
	    position: absolute;
	    top: 5px;
	    right: 5px;
	    width: 177px;
		height: 118px;
	}
	.rp_title{
	    font-size: 16px;
	    margin-bottom: 5px;
	}
	.rp_money {
	    display: flex;
	    align-items: center;
	    font-size: 16px;
	    font-weight: 700;
		img{
			height: 28px;
			width: 28px;
			margin-right: 11px;
		}
	}
	 .rp_tips{
	    font-size: 12px;
	    font-family: PingFangSC-Regular,PingFang SC;
	    font-weight: 400;
	    margin-top: 11px;
		line-height: 20px;
		text-align: center;
	}
}
.top_box{
    background: #fff;
    box-shadow: 0 2px 8px 7px rgba(0,0,0,.06);
	.header_box{
	    display: flex;
	    padding: 11px 22px;
	    justify-content: space-between;
		.title_box {
		    display: flex;
		    align-items: center;
			img{
			    width: 68px;
			    height: 68px;
			}
		}
		.title {
		    display: flex;
		    align-items: center;
		    margin-left: 17px;
		    font-weight: 600;
		    font-size: 16px;
		}
	}
}
.btn_box {
    display: flex;
    justify-content: space-around;
    margin: 17px 11px 0;
	.btn {
	    flex: 1;
	    height: 40px;
	    background: #0064d3;
	    border-radius: 8px;
	    font-size: 14px;
	    font-weight: 400;
	    color: #fff;
	}
	.flexCenter {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.btn1 {
	    margin-left: 17px;
	    color: #fff;
	    background: #0064d3;
	}
}
.manager_box{
    margin: 34px 11px 150px;
	.box{
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    border-bottom: 1px solid #d2d2d2;
	    padding-left: 9px;
	    height: 57px;
		.icon{
		    display: flex;
			img{
				width: 20px;
				height: 20px;
			}
			div{
				margin-left: 17px;
				font-size: 14px;
				font-weight: 400;
				color: #333;
			}
		}
		.right img{
		    width: 8px;
		    height: 14px;
		}
	}
}
.hellotitle{
	line-height: 30px;
	font-size: 20px;
	font-weight: bold;
	color: #000;
	margin: 10px 20px 0 20px;
}
.balance{
	padding: 10px 0px;
	text-align: center;
	margin: 10px;
	margin-bottom: 0;
	p:nth-child(1){
		font-size: 14px;
		margin-bottom: 15px;
	}
	p:nth-child(2){
		color: #000;
		font-size: 14px;
		margin-bottom: 15px;
	}
	p:nth-child(3){
		color: #000;
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 0;
	}
}

/* Ivory, champagne-gold and rose-wine wallet theme. */
.basic_wrap { min-height: 100vh; padding-bottom: calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }
.red_top_bg { background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit { color: #8f251d; }
.hellotitle { margin: 16px 18px 5px; color: #8f251d; font-size: 16px; }
.rp_box { margin: 12px 14px; padding: 12px 18px; border: 1px solid rgba(190, 139, 52, .55); border-radius: 17px; background: linear-gradient(135deg, #fffdf8, #f7deb0 105%); box-shadow: 0 14px 30px rgba(126, 84, 29, .12); }
.balance { margin: 0; }.balance p:nth-child(1) { color: #533126; }.balance p:nth-child(2) { color: #815c45; }.balance p:nth-child(3) { color: #a6233d; font-size: 20px; text-shadow: 0 3px 16px rgba(166, 35, 61, .12); }
.balance .vip0span,
.balance .vip1span,
.balance .vip2span,
.balance .vip3span { border: 1px solid rgba(255, 228, 159, .78); background: linear-gradient(145deg, #f0ca79, #a96b24) !important; color: #251207 !important; box-shadow: 0 3px 10px rgba(0, 0, 0, .24); }
.btn_box { margin: 16px 14px 0; gap: 12px; }
.btn_box .btn,
.btn_box .btn1 {
  border: 1px solid #b9802e;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(126, 84, 29, .13), inset 0 1px 0 rgba(255, 255, 255, .56);
}
.btn_box .btn {
  background: linear-gradient(145deg, #a6233d, #ca5a5b) !important;
  color: #fff9ea !important;
  font-weight: 600;
}
.btn_box .btn1 {
  background: linear-gradient(110deg, #fff7df, #ebc46e) !important;
  color: #8f251d !important;
}
.btn_box .btn:active,
.btn_box .btn1:active { opacity: .8; }
.manager_box { margin: 22px 14px 0; border: 1px solid rgba(190, 139, 52, .5); border-radius: 15px; background: rgba(255, 254, 249, .95); box-shadow: 0 9px 18px rgba(126, 84, 29, .09); overflow: hidden; }.manager_box .box { padding: 0 14px; border-bottom-color: rgba(190, 139, 52, .2); }.manager_box .box .icon div { color: #8f251d; }.manager_box img { filter: none; }

/* Wallet overview mirrors the account center's balance card and menu system. */
.basic_wrap { background: linear-gradient(180deg, #f3f9f8, #ebf5f3); color: #123d42; }.red_top_bg { border-bottom-color: #c7e0dd; background: rgba(255, 255, 255, .97); box-shadow: 0 4px 14px rgba(10, 73, 79, .07); }.red_top_bg .big_tit { color: #073f47; }
.hellotitle { color: #073f47; }.rp_box { border-color: #c9e1de; background: linear-gradient(135deg, #fff, #e8f5f3); box-shadow: 0 14px 30px rgba(12, 75, 79, .12); }.balance p:nth-child(1) { color: #123d42; }.balance p:nth-child(2) { color: #60797c; }.balance p:nth-child(3) { color: #073f47; text-shadow: 0 3px 16px rgba(11, 70, 76, .12); }
.balance .vip0span, .balance .vip1span, .balance .vip2span, .balance .vip3span { border-color: #d9bd78; background: linear-gradient(145deg, #fff4d4, #e8c982) !important; color: #6c4c19 !important; box-shadow: 0 3px 10px rgba(108, 76, 25, .14); }
.btn_box .btn, .btn_box .btn1 { border-color: #0c7b83; box-shadow: 0 8px 16px rgba(11, 70, 76, .13), inset 0 1px rgba(255, 255, 255, .56); }.btn_box .btn { background: #073f47 !important; color: #fff !important; }.btn_box .btn1 { border-color: #a8d5d0; background: #e8f5f3 !important; color: #075963 !important; }
.manager_box { border-color: #c9e1de; border-radius: 16px; background: rgba(255, 255, 255, .95); box-shadow: 0 9px 18px rgba(12, 75, 79, .09); }.manager_box .box { border-bottom-color: #deebea; }.manager_box .box .icon div { color: #173f44; }
</style>
